import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/Aptar_Beauty_HOME.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/Bosch.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/Deloitte.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/Honeywell.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/industry-reports/title-banner/banner.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/industry-reports/title-banner/breadcrumb.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pagination.jsx");
